'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mockedFreeMerchandiseItems = require('self-service-api/constants/mockedFreeMerchandiseItems');

var _mockedFreeMerchandiseItems2 = _interopRequireDefault(_mockedFreeMerchandiseItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var productsAdapter = function productsAdapter(_ref) {
  var productCatalog = _ref.productCatalog,
      customerCurrencyCode = _ref.customerCurrencyCode;

  var additionalInfo = { customerCurrencyCode: customerCurrencyCode, authState: 'AUTHED' };

  var products = productCatalog.reduce(function (aggregate, item) {
    var merchandiseId = item.merchandiseItemId;

    aggregate[merchandiseId] = _extends({
      ownedByHub: item.ownedByHub,
      eligibility: item.eligibility
    }, item.merchandiseItem);

    return aggregate;
  }, _extends({}, _mockedFreeMerchandiseItems2.default));

  return _extends({}, additionalInfo, { products: products });
};

exports.default = productsAdapter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/adapters/productsAdapter.js
// module id = 283
// module chunks = 3 4 5